import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsTicketsCarouselOpen = (quantity: string) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_ACESSO, {
    ref_figma: '11',
    screen: 'minhas raspadinhas',
    flow: 'raspadinha',
    content_action: 'dado carregado',
    quantity,
  })
}

export const analyticsTicketsCarouselHeader = (refFigma: string, actionId: string) => {
  BaseBridge.requestAnalytics(TagEventsEnum.HEADER, {
    ref_figma: refFigma,
    screen: 'minhas raspadinhas',
    flow: 'raspadinha',
    content_action: 'toque',
    action_id: actionId,
    product: 'capitalização',
  })
}

export const analyticsTicketsCarousel = (actionId: string) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '13',
    screen: 'minhas raspadinhas',
    ref_type: 'botão',
    flow: 'raspadinha',
    content_action: 'toque',
    action_id: actionId,
  })
}

export const analyticsTicketCarouselUse = (selectedItem: string) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '14',
    screen: 'minhas raspadinhas',
    ref_type: 'botão',
    flow: 'raspadinha',
    content_action: 'toque',
    action_id: 'usar sortezinha',
    selected_item: selectedItem,
  })
}
